import { ChangeDetectorRef, Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PartnershipDashboardService } from './partnership-dashboard.service';
import { DashboardFilterService } from '../../../diagnostic-dashboard/dashboard-filter/dashboard-filter.service';
import { Subject, Subscription, switchMap } from 'rxjs';
import { GlobalService } from '../../../global/services/global.service';
import { WorkspaceService } from '../../../workspace/workspace.service';
import { generalConfigFromGlobal, hydratedGlobalParams } from '../../../shared/workspace-element-context';

interface Column {
    field: string;
    header: string;
}

interface SelectItem {
    label?: string;
    value: any;
    disabled?: boolean;
}

@Component({
    selector: 'gtw-partnership-dashboard',
    templateUrl: './partnership-dashboard.component.html',
    styleUrls: ['./partnership-dashboard.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})

export class PartnershipDashboardComponent implements OnInit, OnDestroy {
    loadTable: boolean = true;
    


    constructor(public partnershipDashboardService: PartnershipDashboardService,
        public dashboardFilterService: DashboardFilterService,
        private gtwGlobal: GlobalService,
        private gtwWorkspace: WorkspaceService,
        private cdr: ChangeDetectorRef) {
        this.partnerships = [];
        this.partners = [];
    }


    scenarioCode: string = '';
    globalParams: { jcd_key: string; tax_year: string; scenario: string; client_key: string; } | undefined;
    private readonly subs = new Subscription();
    private loadHoDetailsSubject = new Subject<any>();
    private loadProcsSubject = new Subject<any>();
    taxYears: any;
    baseURLs: any = { admin: '', api: '/gtw', custom: '', efile: '', pdfEngine: '', bulkPdfEngine: '' };
    clientKey: any;

    credits_card_details: any = {};
    sourcing_card_details: any = {};
    ti_card_details: any = {};

    selectedFilterParams: any;
    hoDetails: any;

    tableData: any;

    partnershipDisplayedColumns = [
        'LEID',
        'CDR_NO',
        'REPORTING_PERIOD',
        'ME_CODE',
        'TOTAL_PSHIP_AMT',
        'TOTAL_FLOWTHRU_AMT',
        'TOTAL_EXCLUSION_AMT',
        'TOTAL_EXT_PTR_AMT',
        'VARIANCE',
    ];

    gridTitle = this.partnershipDashboardService.gridTitle;

    switch(status: any) {
        console.log(status);
    }

    baseValue!: string;
    filterValue!: string;
    selectedPartnership: any;

    partnerships: SelectItem[] = [];
    partners: any;
    partnersOptions: SelectItem[] = [];

    filterBase(event: any) {
        console.log(event);
        this.filterValue = event;
    }

    saveFilters(event: any) {
        if (event.screen_key == 11588) {
            console.log('dashboard loading', event);

            this.selectedFilterParams = event
            this.partnershipDashboardService.updateSelectedFilterParams(this.selectedFilterParams);

            let params = {
                filing_key: this.selectedFilterParams.filing_key,
                scenario: this.selectedFilterParams.scenario,
                tax_year: this.selectedFilterParams.tax_year,
                jcd_key: this.selectedFilterParams.jcd_key,
                parent_me_string: this.selectedFilterParams.parent_me_string
            }

            this.loadDashboard(params);
        }
    }

    loadDashboard(params: any) {
        this.loadHoDetails(params);

    }

    hoLoading: boolean = false;
    contentLoading: boolean = false;

    cols!: Column[];



    loading: boolean = false;

    isClickable = false;

    ngOnInit(): void {
        this.applyWorkspaceContext();
        this.subs.add(this.gtwWorkspace.setTabActive.subscribe(() => this.applyWorkspaceContext()));
        this.subs.add(this.gtwGlobal.globalParamsChanged$.subscribe(() => this.applyWorkspaceContext()));

        // Only inherit the prior loading state if the service actually has
        // data to back it. Otherwise (fresh visit, or previous visit was
        // torn down mid-load with `hoLoading=true` left in the singleton)
        // we'd render with both loaders spinning forever and no API call
        // queued — the user would have to manually trigger the filter to
        // unstick the screen.
        const cachedMap = this.partnershipDashboardService.getPartnershipsMap();
        const hasCachedPartnerships =
            !!cachedMap && Object.keys(cachedMap).length > 0;
        if (hasCachedPartnerships) {
            this.hoLoading = !!this.partnershipDashboardService.hoLoading;
            this.contentLoading = !!this.partnershipDashboardService.contentLoading;
        } else {
            this.hoLoading = false;
            this.contentLoading = false;
            this.partnershipDashboardService.hoLoading = false;
            this.partnershipDashboardService.contentLoading = false;
        }
        this.partnershipsMap = cachedMap;
        if (this.partnershipsMap) {
            this.partnerships = Object.keys(this.partnershipsMap).map(key => {
                return {
                    label: key,
                    value: this.partnershipsMap[key]
                };
            });
        }

        if (this.partnershipDashboardService.selectedFilterParams) {
            this.selectedFilterParams = this.partnershipDashboardService.getSelectedFilterParams();
          }

        this.selectedPartnership = this.partnershipDashboardService.getSelectedPartnership() || {};
        this.partners = this.partnershipDashboardService.getPartners() || [];
        this.partnersOptions = this.partners.map((partner: any) => {
            return {
                label: partner,
                value: partner
            };
        });

        this.subs.add(
            this.partnershipDashboardService.getCardDetails().subscribe(cardDetails => {
                if (cardDetails) {
                    this.credits_card_details = cardDetails['ho_credits'];
                    this.sourcing_card_details = cardDetails['ho_sourcing'];
                    this.ti_card_details = cardDetails['ho_ti'];
                }
            })
        );

        this.tableData = this.partnershipDashboardService.getTableData() || [{}];

        this.subs.add(this.loadHoDetailsSubject.pipe(
            switchMap(filterParams => this.partnershipDashboardService.getHoDetails('/gtw/', filterParams))
        ).subscribe({
            next: (data: any) => {
                if (!data?.jsonObject || data.jsonObject.length === 0) {
                    // Empty response: the snackbar message is already raised
                    // inside the service. Previously this branch did a bare
                    // `return`, which left `hoLoading=true` (and downstream
                    // `contentLoading=true`) forever — header loader stayed
                    // spinning even though the API answered.
                    console.log('data.jsonObject is null or empty');
                    this.partnershipsMap = {} as any;
                    this.partnerships = [];
                    this.partners = [];
                    this.partnersOptions = [];
                    this.selectedPartnership = {};
                    this.partnershipDashboardService.updatePartnershipsMap(this.partnershipsMap);
                    this.partnershipDashboardService.updatePartners(this.partners);
                    this.partnershipDashboardService.updateSelectedPartnership(this.selectedPartnership);
                    this.hoLoading = false;
                    this.contentLoading = false;
                    this.partnershipDashboardService.hoLoading = this.hoLoading;
                    this.partnershipDashboardService.contentLoading = this.contentLoading;
                    this.cdr.detectChanges();
                    return;
                }
                this.partnershipsMap = {} as any;
                this.partnerships = [];
                for (let obj of data.jsonObject) {
                    if (!this.partnershipsMap[obj.LEID]) {
                        this.partnershipsMap[obj.LEID] = {
                            leidMap: {},
                            ho_combination_key: obj.HO_COMBINATION_KEY,
                            le_name: obj.LE_NAME,
                            year_begin: obj.TAX_YEAR_BEGIN,
                            year_end: obj.TAX_YEAR_END,
                            ein_num: obj.EIN
                        };
                    }

                    if (this.partnershipsMap[obj.LEID].leidMap[obj.LEID]) {
                        this.partnershipsMap[obj.LEID].leidMap[obj.LEID].push(obj.PTR_LEID);
                    } else {
                        this.partnershipsMap[obj.LEID].leidMap[obj.LEID] = [obj.PTR_LEID];
                    }
                }

                this.partnerships = Object.keys(this.partnershipsMap).map(key => {
                    return {
                        label: key,
                        value: this.partnershipsMap[key]
                    };
                });

                let selectedPartnership = this.partnerships[0];

                this.partnershipDashboardService.updatePartnershipsMap(this.partnershipsMap);
                //this.partnershipDashboardService.updatePartnerships(partnerships);
                this.partnershipDashboardService.updateSelectedPartnership(selectedPartnership);

                this.selectPartnership({ value: selectedPartnership.value });
                this.hoLoading = false;
                this.partnershipDashboardService.hoLoading = this.hoLoading;
            },
            error: (err: any) => {
                // Without this, a 4xx/5xx from `/loadJsonObject?action_code=tmr62v`
                // would leave both loaders spinning permanently.
                console.error('getHoDetails failed', err);
                this.hoLoading = false;
                this.contentLoading = false;
                this.partnershipDashboardService.hoLoading = this.hoLoading;
                this.partnershipDashboardService.contentLoading = this.contentLoading;
                this.cdr.detectChanges();
            }
        }));

        this.subs.add(this.loadProcsSubject.pipe(
            switchMap(params => this.partnershipDashboardService.loadProcs('/gtw/', params.filterParams, params.ho_combination_key))
        ).subscribe({
            next: () => {
                this.populateCards();
                this.selectCard({
                    currentTarget: {
                        id: "ti"
                    }
                });
                this.contentLoading = false;
                this.partnershipDashboardService.contentLoading = this.contentLoading;
            },
            error: (err: any) => {
                // Any failure inside the `forkJoin` of the six proc loaders
                // would otherwise leave the content loader spinning.
                console.error('loadProcs failed', err);
                this.contentLoading = false;
                this.partnershipDashboardService.contentLoading = this.contentLoading;
                this.cdr.detectChanges();
            }
        }));


    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }

    private applyWorkspaceContext(): void {
        this.baseURLs = generalConfigFromGlobal(this.gtwGlobal);
        const gp = hydratedGlobalParams(this.gtwGlobal, this.gtwWorkspace);
        this.globalParams = gp;
        this.clientKey = gp?.client_key || gp?.clientKey || '';
        const taxYearValues = this.gtwGlobal.global?.inputs?.tax_year?.values || [];
        this.taxYears = JSON.stringify(taxYearValues);
    }
    objectKeys(obj: any) {
        return Object.keys(obj);
    }

    // `selectedPartnership` holds the raw partnership value when set from a
    // click, but the whole `SelectItem` when restored from the dashboard
    // service cache, so match on `ho_combination_key` instead of identity.
    isPartnershipSelected(partnership: SelectItem): boolean {
        const selected = this.selectedPartnership?.value ?? this.selectedPartnership;
        const key = selected?.ho_combination_key;
        return !!key && key === partnership?.value?.ho_combination_key;
    }


    leidMap: { [key: string]: string[] } = {};
    partnershipsMap: any;
    loadHoDetails(filterParams: any) {
        this.hoLoading = true;
        this.partnershipDashboardService.hoLoading = this.hoLoading;
        this.loadHoDetailsSubject.next(filterParams);
        console.log("filterParams: " + filterParams);
    }

    selectPartnership(event: any) {
            this.partners = [];
            this.partnersOptions = [];
            this.selectedPartnership = event.value || {};

            // Guard: if upstream `getHoDetails` returned an empty/odd payload
            // we can land here without a partnership (or without its
            // `ho_combination_key`). Triggering the proc loader with a
            // missing key makes the backend reject the request, leaving
            // `contentLoading=true` forever via the `forkJoin` error path.
            // Skip the API call entirely in that case and clear the loader.
            if (!this.selectedPartnership || !this.selectedPartnership.ho_combination_key) {
                this.contentLoading = false;
                this.partnershipDashboardService.contentLoading = this.contentLoading;
                this.cdr.detectChanges();
                return;
            }

            this.contentLoading = true;
            this.partnershipDashboardService.contentLoading = this.contentLoading;
            const leidMap = this.selectedPartnership.leidMap || {};
            let leidMapKeys = Object.keys(leidMap);
            if (leidMapKeys.length > 0) {
                this.partners = leidMap[leidMapKeys[0]];
                this.partnershipDashboardService.updatePartners(this.partners);
            }
            this.partnersOptions = this.partners.map((partner: any) => {
                return {
                    label: partner,
                    value: partner
                };
            });

            this.partnershipDashboardService.updateSelectedPartnership(this.selectedPartnership);

            this.loadProcsSubject.next({
                filterParams: this.selectedFilterParams,
                ho_combination_key: this.selectedPartnership.ho_combination_key
            });
    }
    

    switchTableView(key: string) {
        console.log("switched to: " + key);
        const jsonObject = this.partnershipDashboardService.screenDetails[key];

        if (!jsonObject || jsonObject.length === 0) {
            console.log(`jsonObject associated with key "${key}" is null or empty`);
            this.cols = [];
            this.tableData = [{}];
            this.partnershipDashboardService.updateTableData(this.tableData);
            return;
        }

        this.cols = Object.keys(jsonObject[0]).map(key => ({ field: key, header: key }));

        this.tableData = jsonObject;
        this.partnershipDashboardService.updateTableData(this.tableData);

    }

    selectCard(event: any) {
        let divs = document.getElementsByClassName('cards-spacing card-details');

        for (let i = 0; i < divs.length; i++) {
            divs[i].classList.remove('selectedCard');
        }

        let element;
        if (event.currentTarget && event.currentTarget.parentNode) {
            element = event.currentTarget.parentNode;
        } else if (event.currentTarget.id) {
            element = document.getElementById(event.id);
        }

        if (element) {
            element.classList.add('selectedCard');
        }

        let id = event.currentTarget ? event.currentTarget.id : event.id;
        switch (id) {
            case "ti":
                this.gridTitle = "Taxable Income";
                this.partnershipDashboardService.gridTitle = this.gridTitle;
                this.switchTableView("ho_ti_details");
                break;
            case "creds":
                this.gridTitle = "Credits";
                this.partnershipDashboardService.gridTitle = this.gridTitle;
                this.switchTableView("ho_credit_details");
                break;
            case "source":
                this.gridTitle = "Sourcing";
                this.partnershipDashboardService.gridTitle = this.gridTitle;
                this.switchTableView("ho_sourcing_details");
                break;

        }

    }

    populateCards() {
        this.partnershipDashboardService.populateCards();
    }


    isShow: boolean = true;

    showFilter() {
        this.isShow = !this.isShow;
        this.dashboardFilterService.notifyOther({ screen_key: 11588, isEnabled: true });
    }

    closeFilterPanel(event: any) {
        this.isShow = true
    }

    onMouseOver(event: any) {
        event.currentTarget.classList.add('hovered');
        this.changeCursor(true);
    }

    onMouseOut(event: any) {
        event.currentTarget.classList.remove('hovered');
        this.changeCursor(false);
    }

    changeCursor(isHovering: boolean): void {
        this.isClickable = isHovering;
    }


}
